import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUTCDate } from '../../utilities/datetime';

import OrgSVG from '../../assets/org.svg';
import CalendarSvg from '../../assets/calendar.svg';
import StatusSvg from '../../assets/update.svg';
import ListSvg from '../../assets/list.svg';
import ListSelectedSvg from '../../assets/list_selected.svg';
import GridSvg from '../../assets/grid.svg';
import GridSelectedSvg from '../../assets/grid_selected.svg';
import FilterPopover from './filterPopover';

import './Filter.scss';
import { eventTypes } from '../../utilities/eventTypes';
import DropDown from '../common/selectbox/dropDown';

class SuperFeedFilter extends Component {
  state = {
    customerChanged: false,
    filterBy: {"dtTS": "last30d"},
    sortingCriteria: [{"fieldName": "dtTS", "description": "Detected On", "order": "desc"}],
    advanceFilters: [
      {"fieldName": "rrURLYN", "description": "Remove Repeat URL", "value": "N", "type": "boolean"},
      {"fieldName": "incldFP", "description": "Include False Positive URLs", "value": "N", "type": "boolean"}
    ]
  }

  rangeOptions = [
    { name: 'Last 30 days', value: getUTCDate(30), id: getUTCDate(30), code: "last30d" },
    { name: 'Last 60 days', value: getUTCDate(60), id: getUTCDate(60), code: "last60d" },
    { name: 'Last 90 days', value: getUTCDate(90), id: getUTCDate(90), code: "last90d" },
    { name: 'Last 1 year', value: getUTCDate(365), id: getUTCDate(365), code: "last1y" },
    { name: 'Last 3 years', value: getUTCDate(3 * 365), id: getUTCDate(3 * 365), code: "last3y" }
  ]
  statusList = [
    { name: 'AI Suspicious', value: '0', id: '0',eventType : [eventTypes.incident, eventTypes.google_form_password] },
    { name : 'Reported Phish' ,  value :'3' ,id : '3', eventType : [eventTypes.reported_phish]},
    { name: 'PIXM Verified', value: '5', id: '5', eventType : [] },
  ]

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    let { selectedCustomer } = this.props
    if (this.props.selectedCustomer !== prevProps.selectedCustomer) {
      this.state.customerChanged = true
    }
    const filterChanged =prevState.filterBy !== this.state.filterBy ||
            prevState.advanceFilters !== this.state.advanceFilters ||
            prevState.sortingCriteria !== this.state.sortingCriteria;
    if(filterChanged && this.props.onFilterChange instanceof Function) {
      // Call the onFilterChange prop with the selected option
      this.props.onFilterChange(this.state.filterBy, this.state.advanceFilters, this.state.sortingCriteria);
    } else {
      // Handle the case where onFilterChange is not a function
      console.warn("onFilterChange prop is not a function or is missing !!!");
    }
  }

  addUpdateFilter = (fieldName, value) => {
    this.setState(prevState => ({
      filterBy: {
        ...prevState.filterBy,
        [fieldName]: value
      }
    }));
  }

  removeFilter = (fieldName) => {
    this.setState(prevState => {
      const { [fieldName]: removed, ...filterBy } = prevState.filterBy;
      return { filterBy };
    });
  }

  handleCustomerChange = () => {
    this.state.customerChanged = false
  }

  handleAdvanceFilterChange = (fieldName, value, advanceFilters) => {
    let copiedFilters;
    try {
      //Create a deep copy using JSON methods
      copiedFilters = JSON.parse(JSON.stringify(advanceFilters));
    } catch (err) {
      //Fallback to shallow copy if deep copy fails
      console.warn("Failed to deep copy advanceFilters:", err);
      copiedFilters = Array.isArray(advanceFilters) ? [...advanceFilters] : [];
    }
    this.setState({ 
      advanceFilters: copiedFilters
    });
  }
  handleSortBy = (sortByField, sortOrder, sortingCriteria) => {
    let copiedCriteria;
    try {
      //Create a deep copy using JSON methods
      copiedCriteria = JSON.parse(JSON.stringify(sortingCriteria));
    } catch (err) {
      //Fallback to shallow copy if deep copy fails
      console.warn("Failed to deep copy sortingCriteria:", err);
      copiedCriteria = Array.isArray(sortingCriteria) ? [...sortingCriteria] : [];
    }
    this.setState({ 
      sortingCriteria: copiedCriteria
    });
  }

  handleSelect = (event, selectedOption, ctlId, ctlName) => {
    // Update the local state of filter values based on the change in parameters selected
    // Either remove the parameter or update the selected value of parameter based on the parameter and its value selected by user
    // console.log("Selected option in SuperFeed Filter :", selectedOption, event.target, ctlId, ctlName);
    switch (ctlName) {
      case 'sf-dd-status':
        // check if 'All' option is selected if selected Obj is empty
        if (Object.keys(selectedOption).length === 0 || selectedOption.id === 'all') {
          // remove the status parameter from filter state
          this.removeFilter('type');
          this.removeFilter('pxmVrfd')
        } else if(selectedOption.name === 'PIXM Verified') {
          // add or update the value of status parameter in filter state
          this.removeFilter('type');
          this.addUpdateFilter('pxmVrfd', true);
        }
        else {
          // add or update the value of status parameter in filter state
          this.addUpdateFilter('type', selectedOption.value);
          this.addUpdateFilter('pxmVrfd', false);

        }
        break;
      case 'sf-dd-orglist':
        // organization parameter has changed by user
        if (selectedOption.id === 'all') {
          // remove the organization parameter from filter state
          this.removeFilter('custId');
        } else {
          // add or update the value of organization parameter in filter state
          this.addUpdateFilter('custId', selectedOption.id);
        }
        break;
      case 'sf-dd-users':
        // users parameter has changed by user
        if(selectedOption.id === 'allusers') {
          // remove the users name/email based filter parameter from filter state
          this.removeFilter('email');
          this.removeFilter('osCompName');
        }
        break;
      case 'sf-dd-brands':
        // brand parameter has changed by user
        if(selectedOption.id === 'allbrands') {
          // remove the brand parameter from filter state
          this.removeFilter('brNm');
        } else {
          // add or update the value of brand parameter in filter state
          this.addUpdateFilter('brNm', selectedOption.value);
        }
        break;
      case 'sf-dd-time-span':
        // console.log("Search detection date in SuperFeed", selectedOption);
        // date range parameter has changed by user
        let rangeOption = this.rangeOptions.find(option => option.code === selectedOption.code);
        // console.log("Search detection date code ", rangeOption);
        // add or update the value of date range parameter in filter state
        // default value is "last 30 days"
        this.addUpdateFilter('dtTS', rangeOption && rangeOption instanceof Object ? rangeOption.code : 'last30d');
        break;
      default:
        // no default action
        break;
    }
  }

  render() {
    const { viewType, onViewSelect, orgList } = this.props
    // console.log("SuperFeedFilter render - props", viewType);
    const orgListDef = {"codeField":"id","descField":"displayName"};
    const timeSpanDef = {"codeField":"code","descField":"name"};
    const timeSpanList = this.rangeOptions;
    const statusListDef = {"codeField":"value","descField":"name"};
    const statusList = this.statusList;

    return (
      <div className="Mask">
        <div className="filterBar">
          <DropDown
            data={orgList}
            definition={orgListDef}
            id="sf-dd-orglist"
            name="sf-dd-orglist"
            icon={OrgSVG}
            selectionText="Customer: All"
            onSelect={this.handleSelect}
          >
          </DropDown>
          <div className="separator"></div>
          <DropDown
            data={timeSpanList}
            definition={timeSpanDef}
            id="sf-dd-time-span"
            name="sf-dd-time-span"
            icon={CalendarSvg}
            selectionText="Select Time Span"
            defaultValue="Last 30 days"
            showSelectionText={false}
            onSelect={this.handleSelect}
          >
          </DropDown>
          <div className="separator"></div>
          <DropDown
            data={statusList}
            definition={statusListDef}
            id="sf-dd-status"
            name="sf-dd-status"
            icon={StatusSvg}
            selectionText="Status: All"
            onSelect={this.handleSelect}
          >
          </DropDown>
          <div className="separator"></div>
          <div className="filters">
            <FilterPopover
              sortingCriteria={this.state.sortingCriteria}
              onSortByChange={this.handleSortBy}
              advanceFilters={this.state.advanceFilters}
              onAdvanceFilterChange={this.handleAdvanceFilterChange}
            />
          </div>
          <div className="separator"></div>
          <div className="viewName">
            {/* <span>{viewType === 'grid' ? 'Grid View' : 'List View'}</span> */}
          </div>
          <div className="rightSection">
            <div className="separator"></div>
            <div className="viewIcons">
              <div title="List view">
                <img
                  src={viewType === 'list' ? ListSelectedSvg : ListSvg}
                  style={{ height: '25px' }}
                  alt=""
                  onClick={() => onViewSelect('list')}
                />
              </div>
            </div>
            <div className="separator"></div>
            <div className="viewIcons">
              <div title="Grid view">
                <img
                  src={viewType === 'grid' ? GridSelectedSvg : GridSvg}
                  style={{ height: '25px' }}
                  alt=""
                  onClick={() => onViewSelect('grid')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  brandsList: state.entities.customers.brands,
  orgList: state.entities.customers.orglist,
  tokenRoles: state.entities.user.roles,
  filterBy: state.entities.superFeedEvents.filterBy,
  sortBy: state.entities.superFeedEvents.sortBy
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(SuperFeedFilter)
